import { useContext } from 'react';
import { UserPointsContext } from 'contexts';

const useUserPointsContext = () => useContext(UserPointsContext);

export { useUserPointsContext };
